import { SFHelpers, getAllMonths } from "@sf-core";

export const countHoursPerMonths = (data) => {
  // Define month names
  let monthNames = getAllMonths();

  // Initialize totalHours
  let totalChartHours = 0;

  // Get current date and month
  const now = new Date();
  let currMonth = now.getMonth();

  // Initialize processedData with months and 0 hours
  let processedData = monthNames.map((month, index) => ({
    month: monthNames[(index + currMonth + 1) % 12],
    hours: 0,
  }));

  // Loop through data
  data.forEach((item) => {
    // Convert timeStamp to JavaScript Date object
    const timeStamp = new Date(item.timeStamp);
    // Calculate index of month in processedData array
    const monthIndex = (12 + timeStamp.getMonth() - currMonth - 1) % 12;
    // Add the duration in minutes to the month it belongs to
    processedData[monthIndex].hours += item.contentDuration;
  });

  // For each month convert the total duration from minutes to hours
  processedData = processedData.map((item) => ({
    ...item,
    hours: SFHelpers.DurationFormatter(
      item.hours,
      SFHelpers.DurationFormatterOptions.HOURS_ONLY
    ),
  }));

  // Calculate total hours for all months
  for (let i = 0; i < processedData.length; i++) {
    totalChartHours += processedData[i].hours;
  }

  // Round totalChartHours to 1 decimal
  totalChartHours = Number((totalChartHours).toFixed(1));
  if (totalChartHours % 1 === 0) totalChartHours = parseInt(totalChartHours);

  return { processedData, totalChartHours };
};
